import React from 'react';
import { TopupCopy } from '../../utils/topupCopy';
import { NotificationCard } from './NotificationCard';

type Props = {
  onDismiss: () => void;
};

const copy: TopupCopy = {
  title: 'We couldn’t authorise payment',
  message:
    'No credit has been added to your meter, and you haven’t paid us anything.',
  nextStep:
    'To try topping up again, please check:\n• Your card details are correct\n• There’s enough money in your account',
};

export const CouldNotAuthorisePayment = ({ onDismiss }: Props) => (
  <NotificationCard
    id="could-not-authorise-payment"
    variant="error"
    copy={copy}
    onDismiss={onDismiss}
  />
);
